import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import AuthService from 'core/utils/auth/auth-service'

const PrivateRoute = ({ component, ...rest }) => (
  <Route {...rest} render={props => (
    AuthService.loggedIn() ? (
      React.createElement(component, props)
    ) : (
      <Redirect to={{
        pathname: '/login',
        search: props.location.search,
        state: { from: props.location }
      }}/>
    )
  )}/>
)

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/core/utils/auth/PrivateRoute.jsx